import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { isUndefined } from 'lodash';
import { FC, useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import { EditCellContext } from 'src/contexts/EditCellContext';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';

const PriceTextField: FC<GridCellProps> = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const cellClickResult = cellClick?.('');
  const adjustBalanceErrors = cellClickResult?.adjustBalanceErrors;
  const isPriceError = adjustBalanceErrors?.isPriceError ?? false;
  const intl = useInternationalization();

  const { value, handleChange } = useDelayedInputOnchange(props);

  const formatted = '$' + intl.format('{0:n2}', Number(value) || 0);

  return (
    <GridCellBase {...props} className={isPriceError ? 'bg-errorcell' : ''} title={formatted}>
      <NumberInput
        valid={!isPriceError}
        value={isUndefined(value) ? '' : value}
        onChange={handleChange}
        prefix="$"
        decimal={2}
        min={0}
      />
    </GridCellBase>
  );
};

export default PriceTextField;
